import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import Api from 'lib/Api';
import formatter from 'lib/formatter';

class Confirmation extends Component {

  componentDidMount() {
    this.resetCart();
  }

  resetCart() {
    $('#header a.cart').removeClass('filled');
    $('#header a.cart span').remove();
    Api.post(_routes.resetCart, {}).then(response => {});
  }

  downloadFor(product) {
    if (!this.props.order) return null;
    return this.props.order.downloads.find(d => d.skuId == product.skuId && d.productId == product.productId);
  }

  renderAdress(title, className, address) {
    return (
      <div className={`cart-confirmationAddress ${className}`}>
        <p className="cart-confirmationAddressTitle">{title}</p>
        <p className="cart-confirmationAddressText">
          {address.company && address.company.length > 0 &&
            <Fragment>
              {address.company}
              <br/>
            </Fragment>
          }
          {address.first_name} {address.last_name}
          <br/>
          {address.street}
          <br/>
          {address.post_code} {address.city}, {formatter.country(address.country, _metadata.countries)}
        </p>
      </div>
    )
  }

  render() {
    return (
      <div className="cart">
        <h1 className="cart-success">
          {App.t('cart.order_confirmation')}
          <br/>
          <span>{App.t('cart.order_confirmation_email', { email: this.props.email })}</span>
        </h1>

        <div className="cart-confirmationAddresses">
          {this.renderAdress('Adresse de facturation', '-billing', this.props.addresses.billing)}
          {this.renderAdress('Adresse de livraison', '-shipping', this.props.addresses.billing.sameShipping ? this.props.addresses.billing : this.props.addresses.shipping)}
        </div>

        <ul className="cart-products">
          <li className="cart-productsHead">
            <p className="cart-productsHeadLabel -main">{App.t('cart.table_articles')}</p>
            <p className="cart-productsHeadLabel -quantity">{App.t('cart.table_quantity')}</p>
            <p className="cart-productsHeadLabel -price">{App.t('cart.table_price')}</p>
          </li>

          {this.props.products.map((product, i) => {
            const download = this.downloadFor(product);

            return (
              <li className="cartProduct" key={i}>
                <span className="cartProduct-photo">
                  <img className="cartProduct-photoImg" src={product.picture} />
                </span>
                <div className={`cartProduct-main ${download ? '-withDownload' : ''}`}>
                  <strong className="cartProduct-bands">{product.bands}</strong>
                  <span className="cartProduct-name">{product.name}</span>
                  <span className="cartProduct-type">
                    {product.type}
                    {product.includedType ? ` + ${product.includedType}` : null}
                  </span>
                  {download ? <a href={download.url} target="_blank" className="cartProduct-download">{App.t('cart.download')}</a> : null}
                </div>
                <span className="cartProduct-quantity">
                  x {product.quantity}
                </span>
                <span className="cartProduct-price">
                  {product.totalPrice} €
                </span>
              </li>
            )
          })}

          {this.props.amounts.shipping !== null &&
            <li className="cartProduct -shipping">
              <span className="cartProduct-photo" />
              <div className="cartProduct-main">
                <strong className="cartProduct-bands">{App.t('cart.shipping_cost_alt')}</strong>
              </div>
              <span className="cartProduct-quantity -empty">&nbsp;</span>
              <span className="cartProduct-price -shipping">
                {this.props.amounts.shipping} €
              </span>
            </li>
          }
        </ul>

        <div className="cart-footer">
          <p className="cart-footerAmount">
            {App.t('cart.total_amount', { amount: this.props.amounts.total })}
          </p>
        </div>
      </div>
    )
  }

}

Confirmation.propTypes = {
  amounts:          PropTypes.object.isRequired,
  products:         PropTypes.array.isRequired,
  addresses:        PropTypes.array.isRequired,
  order:            PropTypes.object.isRequired,
  email:            PropTypes.string.isRequired,
};

export default Confirmation;
